import React from 'react';

import { useStateStore } from '../stores/useStateStore';
import { useCurrentUser } from '../users';

import { ChatActionsLayer } from './components/ChatActionsLayer';
import { useGlobalCommands } from './hooks/useGlobalCommands';
import { useProactiveMessageListener } from './hooks/useProactiveMessageListener';
import { useChatApplicationID } from './stores/useChatApplicationID';

interface Props {
  children: JSX.Element;
}

export const AkinChatProvider = ({ children }: Props) => {
  const user = useCurrentUser();

  const addItem = useStateStore((state) => state.addChatItem);

  useProactiveMessageListener({
    user,
    addItem,
  });

  useGlobalCommands({
    user,
    addItem,
  });

  // useFiveMinutePing();

  return <ChatActionsLayer>{children}</ChatActionsLayer>;
};

export const useApplicationID = useChatApplicationID;
